import React, { useRef,useState,useEffect} from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setLangKnown} from '../actions'
import Lang from './Lang'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function LangKnown() {
  const resumeLangKnown=useSelector(states=>states.resumeData).langKnown
  const dispatch=useDispatch()
  const history = useHistory();
  const [langs,setResumeLangs]=useState(()=>{
    return resumeLangKnown
  })
  const langRef=useRef()
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setLangKnown(langs))
    history.push("/add-work-experience");
  }
  function addLang(e){
    e.preventDefault();
    setResumeLangs((prevLangs)=>{
      if(prevLangs.includes(langRef.current.value))
        return prevLangs
      return [...prevLangs,langRef.current.value]
    })
  }
  function removeLang(id){
    setResumeLangs((prevLangs)=>{
      return prevLangs.filter((lang,index)=>index!==id)
    })
  }
  useEffect(()=>{
    langRef.current.value=''
  },[langs])
  return (
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <h1><i class="mr-2 fas fa-language"></i>Languages known</h1>
        <form onSubmit={addLang}>
          <input type="text" ref={langRef} placeholder="add language then press enter" required />
        </form>
        <ul>
          {langs.map((lang,index)=>{
            return (<Lang lang={lang} key={index} id={index} removeLang={removeLang} />)
          })}
        </ul>
        {langs!=0 && <motion.button variants={linkVariant} whileHover="hover" className="save-btn" onClick={handleSubmit}>save & next</motion.button>}
      </motion.div>
    </motion.div>
  );
}

